import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../../../v2/lang/Translation';
import replaceHTMLEntityWithSymbol from '../../../../v2/utils/replace-html-entity-with-symbol';
import useStyles from './SocialSharingStatistics.styles';

export function SocialSharingStatistics(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <>
      <h3>
        <Translation>referralsSocialSharing.heading.updated</Translation>
      </h3>
      <ul className={classes.statisticContainer} data-test="SocialSharingStatistics__statisticContainer">
        <li className={classes.statistic}>
          <span className={classes.key}>
            <div>
              <Translation>referralsSocialSharing.yourBalance</Translation>
            </div>
          </span>
          <span
            className={classes.value}
          >
            {replaceHTMLEntityWithSymbol(props.customerCredit)}
          </span>
        </li>
        <li className={classes.statistic}>
          <span className={classes.key}>
            <div>
              <Translation>referralsSocialSharing.friendsReferred</Translation>
            </div>
          </span>
          <span className={classes.value}>
            {props.numReferrals}
          </span>
        </li>
      </ul>
      <div className={classes.explanation}>
        <Translation>referralsSocialSharing.subheading</Translation>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  numReferrals: state.socialSharing.numReferrals,
  customerCredit: state.socialSharing.customerCredit,
});

SocialSharingStatistics.propTypes = {
  numReferrals: PropTypes.number.isRequired,
  customerCredit: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(SocialSharingStatistics);
